import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

interface MetriportEmbedTokenResponse {
  token: string;
}

export const useMetriportEmbedToken = (enabled: boolean) => {
  return useApi<MetriportEmbedTokenResponse>({
    queryOptions: {
      enabled,
      // The server issues a 10-minute token. While the section is open we
      // refetch every ~9 minutes so the iframe always has a non-expired
      // token. gcTime is 0 so a remount never serves a stale near-expiry
      // token from cache — instead the hook starts fresh, the skeleton
      // shows, and the iframe renders with a freshly-issued token.
      staleTime: 9 * 60 * 1000,
      gcTime: 0,
      refetchInterval: 9 * 60 * 1000,
      // Intentionally not patient-scoped: charting issues an org-level
      // session token (no patientId in the request or response). Patient
      // context is added client-side when assembling the embed URL.
      queryKey: QueryKeys.MetriportHIE.EMBED_TOKEN,
      queryFn: async () => {
        const response = await axiosInstance.post<MetriportEmbedTokenResponse>(
          "/charting/hie/metriport/embed-token",
        );
        return response.data;
      },
    },
  });
};
